// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { addToStoreRequestToJson, addToStoresRequestToJson, checkProductVisibilityRequestToJson, checkProductVisibilityResponseFromJson, createStoreCategoryRequestToJson, createStoreCategoryResponseFromJson, deleteStoreCategoryRequestToJson, enableCustomCategoriesForStoreRequestToJson, enableCustomCategoriesForStoreResponseFromJson, getCategoriesForStoreRequestToJson, getCategoriesForStoreResponseFromJson, getMultiStorePricePreviewsRequestToJson, getMultiStorePricePreviewsResponseFromJson, getPublicStoreSalespersonRequestToJson, getPublicStoreSalespersonResponseFromJson, getPublicStoreThemeRequestToJson, getPublicStoreThemeResponseFromJson, getStoreRequestToJson, getStoreResponseFromJson, getStoreWithCategoriesRequestToJson, getStoreWithCategoriesResponseFromJson, hasPartnerSetStoreOrderRequestToJson, hasPartnerSetStoreOrderResponseFromJson, listCategoriesForPackageRequestToJson, listCategoriesForPackageResponseFromJson, listProductsInStoreRequestToJson, listProductsInStoreResponseFromJson, listStorePricePreviewsRequestToJson, listStorePricePreviewsResponseFromJson, listStoreProductVisibilitySummariesRequestToJson, listStoreProductVisibilitySummariesResponseFromJson, listVisibleAddonsForProductRequestToJson, listVisibleAddonsForProductResponseFromJson, removeFromStoreRequestToJson, setCategoriesForPackageRequestToJson, setPackagesInCategoryRequestToJson, setStoreCategoryOrderRequestToJson, updatePublicStoreThemeRequestToJson, updateStoreCategoryRequestToJson, updateStoreRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getStore(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/GetStore', getStoreRequestToJson(request));
    return getStoreResponseFromJson(raw);
}
export function getStore$(request, options) {
    return defer(() => getStoreWithTransport$(getGlobalTransport(), request, options));
}
export function getStoreWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/GetStore', getStoreRequestToJson(request), options)
        .pipe(map(resp => getStoreResponseFromJson(resp)));
}
export async function updateStore(request) {
    await fetchRpc('marketplace_packages.v1.MarketplaceStore/UpdateStore', updateStoreRequestToJson(request));
}
export function updateStore$(request, options) {
    return defer(() => updateStoreWithTransport$(getGlobalTransport(), request, options));
}
export function updateStoreWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/UpdateStore', updateStoreRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function setStoreCategoryOrder(request) {
    await fetchRpc('marketplace_packages.v1.MarketplaceStore/SetStoreCategoryOrder', setStoreCategoryOrderRequestToJson(request));
}
export function setStoreCategoryOrder$(request, options) {
    return defer(() => setStoreCategoryOrderWithTransport$(getGlobalTransport(), request, options));
}
export function setStoreCategoryOrderWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/SetStoreCategoryOrder', setStoreCategoryOrderRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function createStoreCategory(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/CreateStoreCategory', createStoreCategoryRequestToJson(request));
    return createStoreCategoryResponseFromJson(raw);
}
export function createStoreCategory$(request, options) {
    return defer(() => createStoreCategoryWithTransport$(getGlobalTransport(), request, options));
}
export function createStoreCategoryWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/CreateStoreCategory', createStoreCategoryRequestToJson(request), options)
        .pipe(map(resp => createStoreCategoryResponseFromJson(resp)));
}
export async function deleteStoreCategory(request) {
    await fetchRpc('marketplace_packages.v1.MarketplaceStore/DeleteStoreCategory', deleteStoreCategoryRequestToJson(request));
}
export function deleteStoreCategory$(request, options) {
    return defer(() => deleteStoreCategoryWithTransport$(getGlobalTransport(), request, options));
}
export function deleteStoreCategoryWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/DeleteStoreCategory', deleteStoreCategoryRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getCategoriesForStore(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/GetCategoriesForStore', getCategoriesForStoreRequestToJson(request));
    return getCategoriesForStoreResponseFromJson(raw);
}
export function getCategoriesForStore$(request, options) {
    return defer(() => getCategoriesForStoreWithTransport$(getGlobalTransport(), request, options));
}
export function getCategoriesForStoreWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/GetCategoriesForStore', getCategoriesForStoreRequestToJson(request), options)
        .pipe(map(resp => getCategoriesForStoreResponseFromJson(resp)));
}
export async function updateStoreCategory(request) {
    await fetchRpc('marketplace_packages.v1.MarketplaceStore/UpdateStoreCategory', updateStoreCategoryRequestToJson(request));
}
export function updateStoreCategory$(request, options) {
    return defer(() => updateStoreCategoryWithTransport$(getGlobalTransport(), request, options));
}
export function updateStoreCategoryWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/UpdateStoreCategory', updateStoreCategoryRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listCategoriesForPackage(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/ListCategoriesForPackage', listCategoriesForPackageRequestToJson(request));
    return listCategoriesForPackageResponseFromJson(raw);
}
export function listCategoriesForPackage$(request, options) {
    return defer(() => listCategoriesForPackageWithTransport$(getGlobalTransport(), request, options));
}
export function listCategoriesForPackageWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/ListCategoriesForPackage', listCategoriesForPackageRequestToJson(request), options)
        .pipe(map(resp => listCategoriesForPackageResponseFromJson(resp)));
}
export async function setPackagesInCategory(request) {
    await fetchRpc('marketplace_packages.v1.MarketplaceStore/SetPackagesInCategory', setPackagesInCategoryRequestToJson(request));
}
export function setPackagesInCategory$(request, options) {
    return defer(() => setPackagesInCategoryWithTransport$(getGlobalTransport(), request, options));
}
export function setPackagesInCategoryWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/SetPackagesInCategory', setPackagesInCategoryRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function setCategoriesForPackage(request) {
    await fetchRpc('marketplace_packages.v1.MarketplaceStore/SetCategoriesForPackage', setCategoriesForPackageRequestToJson(request));
}
export function setCategoriesForPackage$(request, options) {
    return defer(() => setCategoriesForPackageWithTransport$(getGlobalTransport(), request, options));
}
export function setCategoriesForPackageWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/SetCategoriesForPackage', setCategoriesForPackageRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getStoreWithCategories(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/GetStoreWithCategories', getStoreWithCategoriesRequestToJson(request));
    return getStoreWithCategoriesResponseFromJson(raw);
}
export function getStoreWithCategories$(request, options) {
    return defer(() => getStoreWithCategoriesWithTransport$(getGlobalTransport(), request, options));
}
export function getStoreWithCategoriesWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/GetStoreWithCategories', getStoreWithCategoriesRequestToJson(request), options)
        .pipe(map(resp => getStoreWithCategoriesResponseFromJson(resp)));
}
export async function enableCustomCategoriesForStore(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/EnableCustomCategoriesForStore', enableCustomCategoriesForStoreRequestToJson(request));
    return enableCustomCategoriesForStoreResponseFromJson(raw);
}
export function enableCustomCategoriesForStore$(request, options) {
    return defer(() => enableCustomCategoriesForStoreWithTransport$(getGlobalTransport(), request, options));
}
export function enableCustomCategoriesForStoreWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/EnableCustomCategoriesForStore', enableCustomCategoriesForStoreRequestToJson(request), options)
        .pipe(map(resp => enableCustomCategoriesForStoreResponseFromJson(resp)));
}
export async function getPublicStoreTheme(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/GetPublicStoreTheme', getPublicStoreThemeRequestToJson(request));
    return getPublicStoreThemeResponseFromJson(raw);
}
export function getPublicStoreTheme$(request, options) {
    return defer(() => getPublicStoreThemeWithTransport$(getGlobalTransport(), request, options));
}
export function getPublicStoreThemeWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/GetPublicStoreTheme', getPublicStoreThemeRequestToJson(request), options)
        .pipe(map(resp => getPublicStoreThemeResponseFromJson(resp)));
}
export async function updatePublicStoreTheme(request) {
    await fetchRpc('marketplace_packages.v1.MarketplaceStore/UpdatePublicStoreTheme', updatePublicStoreThemeRequestToJson(request));
}
export function updatePublicStoreTheme$(request, options) {
    return defer(() => updatePublicStoreThemeWithTransport$(getGlobalTransport(), request, options));
}
export function updatePublicStoreThemeWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/UpdatePublicStoreTheme', updatePublicStoreThemeRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function addToStore(request) {
    await fetchRpc('marketplace_packages.v1.MarketplaceStore/AddToStore', addToStoreRequestToJson(request));
}
export function addToStore$(request, options) {
    return defer(() => addToStoreWithTransport$(getGlobalTransport(), request, options));
}
export function addToStoreWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/AddToStore', addToStoreRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function addToStores(request) {
    await fetchRpc('marketplace_packages.v1.MarketplaceStore/AddToStores', addToStoresRequestToJson(request));
}
export function addToStores$(request, options) {
    return defer(() => addToStoresWithTransport$(getGlobalTransport(), request, options));
}
export function addToStoresWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/AddToStores', addToStoresRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function removeFromStore(request) {
    await fetchRpc('marketplace_packages.v1.MarketplaceStore/RemoveFromStore', removeFromStoreRequestToJson(request));
}
export function removeFromStore$(request, options) {
    return defer(() => removeFromStoreWithTransport$(getGlobalTransport(), request, options));
}
export function removeFromStoreWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/RemoveFromStore', removeFromStoreRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function checkProductVisibility(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/CheckProductVisibility', checkProductVisibilityRequestToJson(request));
    return checkProductVisibilityResponseFromJson(raw);
}
export function checkProductVisibility$(request, options) {
    return defer(() => checkProductVisibilityWithTransport$(getGlobalTransport(), request, options));
}
export function checkProductVisibilityWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/CheckProductVisibility', checkProductVisibilityRequestToJson(request), options)
        .pipe(map(resp => checkProductVisibilityResponseFromJson(resp)));
}
export async function listProductsInStore(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/ListProductsInStore', listProductsInStoreRequestToJson(request));
    return listProductsInStoreResponseFromJson(raw);
}
export function listProductsInStore$(request, options) {
    return defer(() => listProductsInStoreWithTransport$(getGlobalTransport(), request, options));
}
export function listProductsInStoreWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/ListProductsInStore', listProductsInStoreRequestToJson(request), options)
        .pipe(map(resp => listProductsInStoreResponseFromJson(resp)));
}
export async function listVisibleAddonsForProduct(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/ListVisibleAddonsForProduct', listVisibleAddonsForProductRequestToJson(request));
    return listVisibleAddonsForProductResponseFromJson(raw);
}
export function listVisibleAddonsForProduct$(request, options) {
    return defer(() => listVisibleAddonsForProductWithTransport$(getGlobalTransport(), request, options));
}
export function listVisibleAddonsForProductWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/ListVisibleAddonsForProduct', listVisibleAddonsForProductRequestToJson(request), options)
        .pipe(map(resp => listVisibleAddonsForProductResponseFromJson(resp)));
}
export async function listStorePricePreviews(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/ListStorePricePreviews', listStorePricePreviewsRequestToJson(request));
    return listStorePricePreviewsResponseFromJson(raw);
}
export function listStorePricePreviews$(request, options) {
    return defer(() => listStorePricePreviewsWithTransport$(getGlobalTransport(), request, options));
}
export function listStorePricePreviewsWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/ListStorePricePreviews', listStorePricePreviewsRequestToJson(request), options)
        .pipe(map(resp => listStorePricePreviewsResponseFromJson(resp)));
}
export async function getMultiStorePricePreviews(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/GetMultiStorePricePreviews', getMultiStorePricePreviewsRequestToJson(request));
    return getMultiStorePricePreviewsResponseFromJson(raw);
}
export function getMultiStorePricePreviews$(request, options) {
    return defer(() => getMultiStorePricePreviewsWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiStorePricePreviewsWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/GetMultiStorePricePreviews', getMultiStorePricePreviewsRequestToJson(request), options)
        .pipe(map(resp => getMultiStorePricePreviewsResponseFromJson(resp)));
}
export async function listStoreProductVisibilitySummaries(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/ListStoreProductVisibilitySummaries', listStoreProductVisibilitySummariesRequestToJson(request));
    return listStoreProductVisibilitySummariesResponseFromJson(raw);
}
export function listStoreProductVisibilitySummaries$(request, options) {
    return defer(() => listStoreProductVisibilitySummariesWithTransport$(getGlobalTransport(), request, options));
}
export function listStoreProductVisibilitySummariesWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/ListStoreProductVisibilitySummaries', listStoreProductVisibilitySummariesRequestToJson(request), options)
        .pipe(map(resp => listStoreProductVisibilitySummariesResponseFromJson(resp)));
}
export async function hasPartnerSetStoreOrder(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/HasPartnerSetStoreOrder', hasPartnerSetStoreOrderRequestToJson(request));
    return hasPartnerSetStoreOrderResponseFromJson(raw);
}
export function hasPartnerSetStoreOrder$(request, options) {
    return defer(() => hasPartnerSetStoreOrderWithTransport$(getGlobalTransport(), request, options));
}
export function hasPartnerSetStoreOrderWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/HasPartnerSetStoreOrder', hasPartnerSetStoreOrderRequestToJson(request), options)
        .pipe(map(resp => hasPartnerSetStoreOrderResponseFromJson(resp)));
}
export async function getPublicStoreSalesperson(request) {
    const raw = await fetchRpc('marketplace_packages.v1.MarketplaceStore/GetPublicStoreSalesperson', getPublicStoreSalespersonRequestToJson(request));
    return getPublicStoreSalespersonResponseFromJson(raw);
}
export function getPublicStoreSalesperson$(request, options) {
    return defer(() => getPublicStoreSalespersonWithTransport$(getGlobalTransport(), request, options));
}
export function getPublicStoreSalespersonWithTransport$(transport, request, options) {
    return transport
        .post('marketplace_packages.v1.MarketplaceStore/GetPublicStoreSalesperson', getPublicStoreSalespersonRequestToJson(request), options)
        .pipe(map(resp => getPublicStoreSalespersonResponseFromJson(resp)));
}
